import { useState, useEffect, memo } from "react";
import { Link, NavLink, useParams } from "react-router-dom";
import { FaBars, FaTimes, FaMoon, FaSun, FaPhone } from "react-icons/fa";
import { useTheme } from "../hooks/useTheme";
import { useBusinessConfig } from "../context/BusinessConfigContext";

const Navbar = () => {
  const { isDark, toggleDark } = useTheme();
  const config = useBusinessConfig();
  const { slug } = useParams();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const { businessName, logo, contact, darkModeEnabled, sections, productsLabel } = config;

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const base = `/${slug}`;
  const navLinks = [
    { label: "Home",     path: base },
    { label: "Services", path: `${base}/services` },
    ...(sections?.products ? [{ label: productsLabel || "Products", path: `${base}/products` }] : []),
    { label: "Gallery",  path: `${base}/gallery` },
    { label: "Contact",  path: `${base}/contact` },
  ];

  return (
    <nav className={`navbar-custom ${scrolled ? "scrolled" : ""}`}>
      <div className="container d-flex align-items-center justify-content-between h-100">
        {/* Brand */}
        <Link to={base} className="d-flex align-items-center gap-2 text-decoration-none">
          {logo
            ? <img src={logo} alt={businessName} style={{ height: 40 }} />
            : <span className="navbar-brand-text">{businessName}</span>}
        </Link>

        {/* Desktop Nav */}
        <div className="d-none d-lg-flex align-items-center gap-1">
          {navLinks.map((l) => (
            <NavLink key={l.path} to={l.path} end={l.path === base}
              className={({ isActive }) => `nav-link-custom ${isActive ? "active" : ""}`}>
              {l.label}
            </NavLink>
          ))}
        </div>

        {/* Actions */}
        <div className="d-flex align-items-center gap-2">
          {darkModeEnabled && (
            <button onClick={toggleDark} className="btn btn-sm"
              style={{ background: "none", border: "1px solid var(--border-color)", borderRadius: 8, color: "var(--text)", width: 36, height: 36, display: "flex", alignItems: "center", justifyContent: "center" }}>
              {isDark ? <FaSun /> : <FaMoon />}
            </button>
          )}
          <a href={`tel:${contact.phone}`} className="btn-primary-custom d-none d-md-inline-flex"
            style={{ padding: "8px 18px", fontSize: "0.85rem" }}>
            <FaPhone /> Call Now
          </a>
          <button className="d-lg-none btn btn-sm" onClick={() => setMenuOpen(!menuOpen)}
            style={{ background: "none", border: "1px solid var(--border-color)", borderRadius: 8, color: "var(--text)", width: 36, height: 36, display: "flex", alignItems: "center", justifyContent: "center" }}>
            {menuOpen ? <FaTimes /> : <FaBars />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div style={{ background: "var(--card-bg)", borderTop: "1px solid var(--border-color)", padding: "12px 0" }}>
          <div className="container d-flex flex-column gap-1">
            {navLinks.map((l) => (
              <NavLink key={l.path} to={l.path} end={l.path === base}
                className={({ isActive }) => `nav-link-custom ${isActive ? "active" : ""}`}
                onClick={() => setMenuOpen(false)}>
                {l.label}
              </NavLink>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
};

export default memo(Navbar);
